module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "element element-bodymatter element-container-single element-type-chapter element-with-heading",
    attrs: {
      "epub:type": "chapter",
      "id": "chapter-1",
      "role": "doc-chapter"
    }
  }, [_c('div', {
    staticClass: "heading heading-container-single heading-size-full heading-format-full heading-alignment-flexible heading-without-image"
  }, [_c('div', {
    staticClass: "heading-contents"
  }, [_c('div', {
    staticClass: "title-subtitle-block title-block-title-is-element-number"
  }, [_c('div', {
    staticClass: "element-number-block"
  }), _vm._v(" "), _c('div', {
    staticClass: "title-block"
  }, [_c('h1', {
    staticClass: "element-title case-upper"
  }, [_c('span', {
    staticClass: "element-number-term"
  }, [_vm._v("CHAPTER")]), _vm._v(" "), _c('span', {
    staticClass: "element-number-number"
  }, [_vm._v("ONE")])])]), _vm._v(" "), _c('h2', {
    staticClass: "element-subtitle case-upper"
  }, [_vm._v("JANUARY 13")])])])]), _vm._v(" "), _c('div', {
    staticClass: "text",
    attrs: {
      "id": "chapter-1-text"
    }
  }, [_c('p', {
    staticClass: "first first-in-chapter first-full-width"
  }, [_vm._v("She never saw him, never heard him. The first she was aware of anything was a torrent of pain and a thud when the broad blade sank into the middle of her back. She cried out as she dropped to the pavement, one hand stretched out to break her fall, the other automatically reaching behind and up her back to the source of her agony.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Then came the soft pad of his feet hurrying to her, the pressure of his knee in her back, the rough feel of a woollen balaclava on her cheek and his hot breath in her ear.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘Be cool, babe, this’ll only take a few seconds.’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Her confused, tortured mind flooded with horror. He was going to rape her.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("He yanked the knife from her back. It hurt almost as much as its initial strike, but Shana was already too weak, too delirious to scream. She could only gurgle a protest. Blood was already dripping from her mouth.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("And then the blade came round her neck. He yanked her head back and Shana experienced the unbearable torment of the sharpened blade slicing open her throat…")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("And then there was nothing.")]), _vm._v(" "), _c('div', {
    staticClass: "ornamental-break"
  }, [_c('div', {
    staticClass: "ornamental-break-block ornamental-break-aspect-wide"
  }, [_c('div', {
    staticClass: "ornamental-break-size-container ornamental-break-width-563"
  }, [_c('img', {
    staticClass: "ornamental-break-image",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "images/break-rule-gradient-screen.png"
    }
  })])])]), _vm._v(" "), _c('p', {
    staticClass: "first first-in-section first-full-width"
  }, [_vm._v("He picked her up, threw her over his shoulder, and with a check both ways to ensure there was no traffic and – more importantly – no witnesses, crossed the road into Back Field.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("She was light, easy to carry, even across ten yards of rough ground. It was the way of these modern girls; so heavy that they couldn’t be moved, or so light that they were practically anorexic.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("He dropped her body into the deeper grasses and stood back a moment, admiring his handiwork. She was easy. Most of them would be, but at this hour it was almost too simple. She was tanked up, full of drink, barely aware of who she was, never mind where she was going. The others would be riskier.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("He looked down at the lifeless body. Below the hem of her chunky jacket, the thin, lemon dress had ridden up, baring her slender legs and thighs. She’d wet herself. He knew that for a fact. He could smell the ammonia when she sagged over his shoulder. Her bowels had moved, too. Even through the balaclava mask, the stench still filled his nostrils.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Not that it would matter to the press when they got hold of the story. They’d assume it was a sex attack. And he was so considerate that after raping and wasting her,  he put her kickers back on? The idea was laughable.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("His all-black clothing was spotted with her blood, and like her knickers, it stank of her  involuntary evacuation. It was not a problem. He had another complete outfit at home, and this lot could go in the washing machine.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("He made his way back to the corner of Bradford Hill Close, and along the narrow street, where he climbed into his Renault Clio, inserted the key in the ignition, and with a wolfish grin of greedy satisfaction, removed his balaclava.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("One down, four to go.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2924e81b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chapter-001.vue
// module id = 72
// module chunks = 0